import { useTranslation } from "react-i18next";
import { parseHtml } from "@components/HTMLParser/utils";
import { Notification } from "@components/Notification/Notification";
import { useBannerMessagesQuery } from "@services/messages/queries";

export const GjensidigeInsuranceNotification: React.FC = () => {
  const { t } = useTranslation();
  const { data: bannerMessages } = useBannerMessagesQuery();

  const exists = bannerMessages?.some(
    (banner) => banner.bannerType === "gjensidgeInsuranceNotification",
  );

  if (!exists) {
    return null;
  }

  return (
    <Notification
      title={t("gjensidigeInsuranceNotification.title")}
      description={parseHtml(t("gjensidigeInsuranceNotification.description"))}
      imagePath="/images/notification/insurance-icon.png"
      variant="big"
      color="orange"
    />
  );
};
